<template lang="html">
  <header class="page-header">
    <slot />
  </header>
</template>

<script>
export default {
  name: 'PageHeader'
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/base/theme'
@import '../stylesheets/helpers/mixins'

.page-header
  display: flex
  background: #fff
  align-items: center
  position: sticky
  top: 0
  justify-content: space-between
  width: 100%
  z-index: 2
  padding: $gap-small
  border-bottom: 1px solid $color-border

  .btn
    padding: 10px

    *
      margin: 0 $gap-x-small

    a
      margin: 0
      color: #fff

  .tier
    a
      opacity: 0
      animation: fadeIn .3s .5s ease-in-out
      animation-fill-mode: forwards

  @include media($media-gt-small)
    width: 100%
    padding: $gap-medium $gap-large

  .heading, .header-actions
    display: flex
    align-items: center

  .heading
    text-transform: capitalize
    margin-right: $gap-small

  .header-actions
    *
      margin: 0 $gap-x-small

    span, a
      font-size: 9px
      text-align: center

      @include media($media-gt-medium)
        font-size: 12px

  h1
    margin: 0 $gap-small 0 0
    font-weight: normal
    font-size: 12px
    letter-spacing: 0
    max-width: 150px
    white-space: nowrap
    text-overflow: ellipsis
    overflow: hidden

    @include media($media-gt-small)
      max-width: none
      font-size: 18px

    a
      @include themify($themes)
        color: themed('color-body')
</style>
